import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/api";
import { ChatTeardropDots } from "@phosphor-icons/react";

// Black "tell us what you thought" CTA card. Auto-hides until an admin
// publishes feedback in Admin → Feedback. Mirrors QuizCTACard / BingoCTACard.
export default function FeedbackCTACard() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    api.get("/feedback/config").then((r) => setConfig(r.data)).catch(() => setConfig({}));
  }, []);

  if (!config?.published) return null;

  const submitted = config.has_submitted;

  return (
    <Link
      to="/feedback"
      data-testid="feedback-cta-card"
      className={`flex items-center gap-3 p-4 rounded-sm transition-colors ${submitted
        ? "bg-[#FFFFFF] border border-[#E5E9F0] hover:border-[#000000]"
        : "bg-[#000000] text-[#FFFFFF] hover:bg-[#1c1c24]"}`}
    >
      <ChatTeardropDots
        size={22}
        weight="duotone"
        className={`flex-shrink-0 ${submitted ? "text-[#000000]" : "text-[#43C4E3]"}`}
      />
      <div className="min-w-0 flex-1">
        <div className="font-display text-base">
          {submitted ? "Thanks for your DFTB26 feedback" : "Tell us what you thought of DFTB26"}
        </div>
        <div className={`text-xs ${submitted ? "text-[#7A828C]" : "text-[#43C4E3]/90"}`}>
          {submitted
            ? "Quiz answers are in your inbox - we appreciate it."
            : "Five quick questions. We'll email you the quiz answers in return."}
        </div>
      </div>
      <span className={`font-mono-time text-xs uppercase tracking-widest ${submitted ? "text-[#000000]" : "text-[#43C4E3]"}`}>
        {submitted ? "View →" : "Open →"}
      </span>
    </Link>
  );
}
